import { DomSanitizer } from '@angular/platform-browser';
import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ElementRef,
  Renderer2
} from '@angular/core';
import { DropdownService } from './dropdown.service';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent implements OnInit {
  @Input()
  actions: any;

  @Input()
  type: string;

  @Input()
  id: string;

  _open = false;
  menu = '';
  finalMenu : any;

  items: Array<any> = [];

  constructor(
    private dropdownService: DropdownService,
    private renderer: Renderer2,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {

  }

  getItems() {
    this.menu = '';
    this.dropdownService.getItems({ type: this.type, id: this.id });

    this.dropdownService.onReturnedItems.subscribe((items) => {
      this.actions = items;
    })
  }

  execAction(id, type) {
    this.dropdownService.execAction({ id: id, type: type });
  }


}
